import type { FC, SVGProps } from 'react'

export const EducationDatasetOptimization: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.84277 14.7057C8.26343 18.1835 9.68409 21.6613 12.5253 21.6613C18.2078 21.6613 18.208 7.75 23.8905 7.75C25.6231 7.75 26.8275 9.04339 27.8257 10.8414C28.4644 11.9918 29.0187 13.3487 29.573 14.7057"
      stroke="url(#paint0_linear_4078_19810)"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.3847 11.7249C22.8877 12.7122 23.3463 13.8317 23.8201 14.9896C23.9769 15.373 24.4148 15.5567 24.7982 15.3998C25.1816 15.243 25.3652 14.8051 25.2084 14.4217L25.199 14.3987L25.1989 14.3986C24.669 13.1032 24.1194 11.7597 23.4865 10.598C23.4621 10.5533 23.4375 10.5086 23.4127 10.4641C23.2077 10.6117 22.9485 10.8761 22.6263 11.3486C22.5446 11.4684 22.4642 11.5939 22.3847 11.7249ZM19.6177 7.07675C19.365 7.02657 19.1004 7 18.8233 7C17.0377 7 15.7732 8.10986 14.8246 9.50114C13.8906 10.8709 13.1547 12.67 12.4582 14.3725L12.4582 14.3725L12.4381 14.4217C11.9613 15.5871 11.5015 16.7072 11.0028 17.6867C11.0822 17.8176 11.1626 17.9431 11.2443 18.0629C11.5663 18.5352 11.8255 18.7996 12.0305 18.9472C12.6965 17.7518 13.2634 16.366 13.8063 15.0388L13.8264 14.9897C14.5468 13.2288 15.2284 11.5715 16.0639 10.3462C16.7874 9.28498 17.5412 8.67083 18.4249 8.53089C18.4322 8.52018 18.4395 8.50949 18.4467 8.49881C18.7759 8.0161 19.1637 7.52589 19.6177 7.07675ZM8.23532 22.3343C7.78146 21.8853 7.39373 21.3952 7.0647 20.9126C7.0574 20.9019 7.05012 20.8912 7.04285 20.8804C6.15909 20.7405 5.40538 20.1263 4.68186 19.0652C3.84637 17.8398 3.16471 16.1825 2.44436 14.4217C2.28752 14.0383 1.84959 13.8547 1.46622 14.0115C1.08285 14.1683 0.899202 14.6063 1.05604 14.9897L1.07616 15.0388C1.77263 16.7414 2.50857 18.5404 3.44252 19.9102C4.39113 21.3015 5.65569 22.4113 7.44122 22.4113C7.7182 22.4113 7.98265 22.3846 8.23532 22.3343Z"
      fill="url(#paint1_linear_4078_19810)"
      fillOpacity="0.6"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4078_19810"
        x1="6.84277"
        y1="14.7057"
        x2="29.573"
        y2="14.7057"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79F9FB" />
        <stop offset="1" stopColor="#90FEAD" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4078_19810"
        x1="1.12652e-07"
        y1="14"
        x2="25"
        y2="14.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
)
